module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei3.svg";